
export const HistoryTabFilters = ({
    actionType,
    selectedActionType,
    onActionTypeChange,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    performBy,
    onPerformByChange,
    onClearFilters
}) => {

    const hasActiveFilters = Boolean(selectedActionType || startDate || endDate || performBy);

    return (
        <>
            <div className="row g-2 align-items-end mb-3">
                <div className="col-sm-12 col-md-2">
                    <label className="form-label mb-1">Action Type</label>
                    <select
                        className="form-select"
                        id="selectActionType"
                        value={selectedActionType ?? ""}
                        onChange={(e) => onActionTypeChange(e.target.value)}
                    >
                        <option value="">All</option>
                        {
                            actionType?.data?.length > 0 &&
                            actionType.data.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.actionName}
                                </option>
                            ))
                        }
                    </select>
                </div>

                <div className="col-sm-12 col-md-2">
                    <label className="form-label mb-1">Start Date</label>
                    <input
                        type="date"
                        className="form-control"
                        id="startDateFilter"
                        value={startDate ?? ""}
                        max={endDate || undefined}
                        onChange={(e) => onStartDateChange(e.target.value)}
                    />
                </div>

                <div className="col-sm-12 col-md-2">
                    <label className="form-label mb-1">End Date</label>
                    <input
                        type="date"
                        className="form-control"
                        id="endDateFilter"
                        value={endDate ?? ""}
                        min={startDate || undefined}
                        onChange={(e) => onEndDateChange(e.target.value)}
                    />
                </div>

                <div className="col-sm-12 col-md-2">
                    <label className="form-label mb-1">Performed By</label>
                    <select
                        className="form-select"
                        id="selectActionType"
                        value={performBy ?? ""}
                        onChange={(e) => onPerformByChange(e.target.value)}
                    >
                        <option value="">All</option>
                        <option value="system">System</option>
                        <option value="agent">Agent</option>
                        <option value="contact">Contact</option>
                        <option value="whise">Whise</option>
                        <option value="third party api">Third Party API</option>
                    </select>
                </div>

                <div className="col-sm-12 col-md-4">
                    <div className="d-flex">
                        <button
                            className="site-btn px-5"
                            disabled={!hasActiveFilters}
                            style={{ opacity: hasActiveFilters ? 1 : 0.5 }}
                            onClick={onClearFilters}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};